/**
 * 关闭首页眼睛
 * 目前适用于卡牛
 */
import useragent from '@common/useragent'
import { call } from './bridge'

/**
 * @param isOpen {boolean} 是否打开眼睛
 */
export default (isOpen = false) => {
  if (useragent.isKaniu) {
    call('cardniu://app/financeWalletEntranceUpdate?opt=' + (isOpen ? '3' : '2'))
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestCloseEye.js